import { Color } from '@diritto/common/style/color';
import { FontWeight } from '@diritto/common/style/typography';
import { ellipsis } from '@diritto/common/utils/string';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ContentBodyPadding, HeaderNavBarHeight } from 'constants/layout';
import { ZIndex } from 'constants/zIndex';
import React, { ReactNode } from 'react';
import { getTextLineStyle } from 'styles/common';
import { MoreMenu } from 'ui-components/common/MoreMenu';
import { MenuItem } from 'ui-components/common/MoreMenuList';

export interface HeaderNavigationBarProps {
  title?: string | ReactNode;
  leftButtons?: ReactNode[];
  rightButtons?: ReactNode[];
  titleColor?: string;
  hiddenMenu?: MenuItem[];
  className?: string;
}

export const HeaderNavigationBar = ({
  title,
  leftButtons,
  rightButtons,
  titleColor = Color.Black,
  hiddenMenu,
  className,
}: HeaderNavigationBarProps) => (
  <StyledContainer className={className}>
    {leftButtons && <StyledLeftButtonList>{leftButtons}</StyledLeftButtonList>}
    {title && typeof title === 'string' ? (
      <StyledText color={titleColor}>{ellipsis(title ?? '', 14)}</StyledText>
    ) : (
      (title ?? '')
    )}
    <StyledRightWrapper>
      {rightButtons && <StyledRightButtonList>{rightButtons}</StyledRightButtonList>}
      {hiddenMenu && hiddenMenu.length > 0 && <StyledMoreMenu menu={hiddenMenu} vertical />}
    </StyledRightWrapper>
  </StyledContainer>
);

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${HeaderNavBarHeight}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${ContentBodyPadding}px;

  z-index: ${ZIndex.NavBar};
`;

const StyledRightWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const StyledText = styled.p(
  ({ color }: { color: string }) => css`
    text-align: center;
    color: ${color};
    font-weight: ${FontWeight.Bold};
    ${getTextLineStyle(1)};

    position: absolute;
    top: 0;
    left: 0;

    line-height: ${HeaderNavBarHeight}px;
    width: 100%;
  `,
);

const StyledButtonList = styled.section`
  display: flex;
  justify-self: flex-start;
  align-items: center;
  gap: 16px;

  z-index: ${ZIndex.NavBar};
`;

const StyledLeftButtonList = styled(StyledButtonList)`
  margin-right: 8px;
`;

const StyledRightButtonList = styled(StyledButtonList)`
  margin-left: 8px;
`;

const StyledMoreMenu = styled(MoreMenu)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-left: 16px;
`;
